import { supabase } from "./supabaseClient";
import { loadNicheRollup } from "./nicheRollupLoader";

// The signed-in account's niche roll-up (counts and unlock progress per niche).
export function fetchNicheRollup(agencyId) {
  return loadNicheRollup(supabase, agencyId);
}
